export default "__VITE_ASSET__6dL_1vuJ__"